module.exports = __webpack_public_path__ + "img/update00-01.230461c5.svg";